import Image from 'next/image';
import styled from 'styled-components';
import { rgbDataURL } from 'utils';
import { ComponentProps } from 'react';
import Bugsnag from '@bugsnag/js';
import { cloudFlareLoader, getShimmerBase64 } from 'utils/images';

/**
 * This falls back to an empty string if the URL is invalid.
 */
export const getPathnameFromUrl = (url: string): string => {
  try {
    return new URL(url).pathname.slice(1);
  } catch (e) {
    console.error('Invalid URL for image source:', url, e);
    Bugsnag.notify(`Invalid URL for image source: ${url}`, e);
    return '';
  }
};

/**
 * Use getPathnameFromUrl to extract the pathname from a URL and pass it to the
 * src prop.
 */
export default function NextImageWithShimmer(props: ComponentProps<typeof Image>) {
  const { loader, alt } = props;

  return (
    <StyledImage
      alt={alt || ''}
      placeholder={getShimmerBase64(100, 100)}
      blurDataURL={rgbDataURL(0, 0, 0)}
      loader={loader || cloudFlareLoader}
      {...props}
    />
  );
}

const StyledImage = styled(Image)`
  filter: initial !important;
`;
